const MAX_CHAT_INPUT_LENGTH = 1500;

module.exports = {
  MAX_CHAT_INPUT_LENGTH,
};
